<template>
  <ListItem buttonIcon="chevron-down-sharp">
    <slot />
  </ListItem>
</template>

<script>
import ListItem from './widgets/Accordion/item';

export default {
  name: 'PriceTableAccordion',

  components: {
    ListItem,
  },

  mounted() {
    this.checkAnchorLink();
    window.addEventListener('hashchange', this.checkAnchorLink);
    this.$el.addEventListener('click', this.handleLinkClick);
  },

  beforeDestroy() {
    window.removeEventListener('hashchange', this.checkAnchorLink);
    this.$el.removeEventListener('click', this.handleLinkClick);
  },

  methods: {
    handleLinkClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link) {
        return;
      }

      const hash = link.getAttribute('href');
      if (hash && hash.startsWith('#') && hash.length > 1) {
        event.preventDefault();
        window.location.hash = hash;
        this.checkAnchorLink();
      }
    },
    checkAnchorLink() {
      const { hash } = window.location;
      const targetEl = hash ? document.getElementById(hash.replace('#', '')) : null;
      const accordionItem = targetEl?.querySelector('.accordion__item');

      if (!hash || !targetEl || !targetEl.classList.contains('accordion__row') || !accordionItem) {
        return;
      }

      let scrollTarget = targetEl.previousElementSibling;
      if (scrollTarget && scrollTarget.classList.contains('accordion__description')) {
        scrollTarget = scrollTarget.previousElementSibling;
      }

      const target = (scrollTarget && scrollTarget.classList.contains('accordion__title'))
        ? scrollTarget
        : targetEl;

      window.scrollTo({
        top: target.offsetTop,
        behavior: 'smooth',
      });

      if (!accordionItem.classList.contains('accordion__item_active')) {
        const button = accordionItem.querySelector('.accordion__item-button');
        if (button) {
          button.click();
        }
      }
    },
  },
};
</script>
